import React from "react";
import {
    Box,
    Flex,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Badge,
    Button,
    VStack,
    Icon,
    TableContainer,
    useToast,
} from "@chakra-ui/react";
import { FiPlay, FiInfo } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";
import axios from "axios";
import { api_url } from "../../url";

const SIDEBAR_WIDTH = "240px";

const CronJobs = () => {
    const toast = useToast();

    const cronJobs = [
        {
            name: "Weekly Loss Bonus",
            schedule: "0 0 * * 1",
            description: "Calculates and awards weekly cashback bonus to players based on their net loss from the previous week (Mon-Sun).",
            lastRun: "Last Monday at 00:00 UTC",
            nextRun: "Next Monday at 00:00 UTC",
            status: "Active",
            endpoint: "/bonus/trigger-weekly",
        }
    ];

    const handleRunManual = async (endpoint) => {
        try {
            const token = localStorage.getItem("token");
            await axios.post(`${api_url}${endpoint}`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast({
                title: "Cron Job Triggered",
                description: "The task has been started successfully.",
                status: "success",
                duration: 3000,
            });
        } catch (error) {
            toast({
                title: "Failed to Trigger",
                description: error.response?.data?.message || error.message,
                status: "error",
                duration: 3000,
            });
        }
    };

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="#f8f9fd"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                <Flex justify="space-between" align="center" mb={8}>
                    <Box>
                        <Text fontSize="2xl" fontWeight="700" color="#344767">
                            Cron Jobs
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                            View and manage automated system tasks.
                        </Text>
                    </Box>
                </Flex>

                <VStack spacing={6} align="stretch">
                    <Box bg="white" borderRadius="12px" boxShadow="sm" overflow="hidden" border="1px solid #f0f2f5">
                        <TableContainer>
                            <Table variant="simple">
                                <Thead bg="#4c3cff">
                                    <Tr>
                                        <Th color="white" textTransform="none">Task Name</Th>
                                        <Th color="white" textTransform="none">Schedule (Cron)</Th>
                                        <Th color="white" textTransform="none">Next Run</Th>
                                        <Th color="white" textTransform="none">Status</Th>
                                        <Th color="white" textTransform="none" textAlign="right">Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {cronJobs.map((job, index) => (
                                        <Tr key={index} _hover={{ bg: "gray.50" }}>
                                            <Td>
                                                <VStack align="start" spacing={0}>
                                                    <Text fontWeight="700" color="#344767">{job.name}</Text>
                                                    <Text fontSize="xs" color="gray.500" maxW="400px" whiteSpace="normal">
                                                        {job.description}
                                                    </Text>
                                                </VStack>
                                            </Td>
                                            <Td>
                                                <Badge colorScheme="blue" variant="subtle" px={2} borderRadius="md">
                                                    {job.schedule}
                                                </Badge>
                                            </Td>
                                            <Td fontSize="sm" color="#344767">{job.nextRun}</Td>
                                            <Td>
                                                <Badge colorScheme="green" variant="solid" borderRadius="full" px={3}>
                                                    {job.status}
                                                </Badge>
                                            </Td>
                                            <Td textAlign="right">
                                                <Button
                                                    leftIcon={<FiPlay />}
                                                    size="sm"
                                                    colorScheme="orange"
                                                    variant="outline"
                                                    onClick={() => handleRunManual(job.endpoint)}
                                                >
                                                    Run Now
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* Instructions */}
                    {/* <Box bg="blue.50" p={6} borderRadius="12px" border="1px solid" borderColor="blue.100">
                        <Flex gap={3}>
                            <Icon as={FiInfo} color="blue.500" boxSize={6} mt={1} />
                            <Box>
                                <Text fontWeight="700" color="blue.800" mb={2}>Technical Information</Text>
                                <Text fontSize="sm" color="blue.700" mb={4}>
                                    Cron jobs are automated tasks that run on the server. If you are using a hosting panel like cPanel or a custom VPS, you should ensure that your application is running continuously (using a process manager like PM2) so these scheduled tasks can execute.
                                </Text>
                                <VStack align="start" spacing={2}>
                                    <Text fontSize="xs" fontWeight="bold" color="blue.900">Recommended Server Setup:</Text>
                                    <Box bg="white" p={2} borderRadius="md" w="full" fontSize="xs" fontFamily="monospace" border="1px solid" borderColor="blue.200">
                                        pm2 start index.js --name jsk-api
                                    </Box>
                                </VStack>
                            </Box>
                        </Flex>
                    </Box> */}
                </VStack>
            </Box>
        </>
    );
};

export default CronJobs;
